import { map, takeUntil } from 'rxjs/operators';

import { ReportFilterField, ReportFilterFieldType, ReportFilterFieldTypes } from '@mode/filters/util';
import { FeatureFlagsFacade } from '@mode/shared/contract-common';
import { DataViewFacade } from '@mode/switch-views/contract';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MixableBaseController } from '~/common/component';
import { AppStore } from '~/types/main.types';
import { ReportFilterService } from '../../services/report-filter-service';
import { reportFilterFieldsSelectorWithDatasets } from './../../reducers/selectors';

export default class InsertFilterModalController extends MixableBaseController {
  static $inject = [
    'RxStoreService',
    'ReportFilterService',
    'DataViewFacade',
    '$timeout',
    '$uibModalInstance',
    'FeatureFlagsFacade',
  ];

  private selectedField: ReportFilterField;
  private fields: ReportFilterFieldTypes[];
  public queryDatasetCount$: Observable<{}>;
  public message: any;

  constructor(
    private rxStore: AppStore,
    private _reportFilterService: ReportFilterService,
    private dataViewFacade: DataViewFacade,
    private $timeout,
    private $uibModalInstance,
    public featureFlag: FeatureFlagsFacade
  ) {
    super();

    this.rxStore
      .select(reportFilterFieldsSelectorWithDatasets)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((filterFields) => this.loadFields(filterFields));

    const hasQueries = [];
    const hasDatasets = [];

    this.queryDatasetCount$ = this.dataViewFacade.enhancedDatasetResults$.pipe(
      switchMap((datasetResult) => datasetResult),
      map((datasetResult) => {
        datasetResult.isLocal === true
          ? hasQueries.push(datasetResult.isLocal)
          : hasDatasets.push(datasetResult.isLocal);
        return {
          queryCount: hasQueries.length,
          datasetCount: hasDatasets.length,
        };
      })
    );
  }

  handleSelection($id) {
    this.selectedField = this.getFieldById($id, this.fields);
  }

  loadFields(fields: ReportFilterFieldTypes[]) {
    this.fields = fields;
  }

  insertFilter() {
    if (this.selectedField) {
      this._reportFilterService.createReportFilter(this.selectedField);
    }

    this.$uibModalInstance.close(this.selectedField);
  }

  private getFieldById(id: string, filterFields: ReportFilterFieldTypes[]): ReportFilterField {
    let result = null;

    for (const field of filterFields) {
      switch (field.type) {
        case ReportFilterFieldType.Field:
          if (field.id === id) {
            return field;
          }
          break;
        case ReportFilterFieldType.Folder:
          result = this.getFieldById(id, field.fields);
          if (result) {
            return result;
          }
      }
    }

    return result;
  }
}
